import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { SectionHeader } from "./Reveal";
import { SECURITY_LAYERS } from "../../data/site";
import { EASE } from "../../lib/motion";

export default function SecurityLayers() {
  return (
    <div>
      <div className="grid items-end gap-8 lg:grid-cols-[1.2fr_1fr]">
        <SectionHeader
          eyebrow="Seguridad"
          title={
            <>
              La seguridad no es una característica.
              <br />
              <span className="text-gradient">Es parte de nuestra arquitectura.</span>
            </>
          }
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="hidden justify-self-end lg:block"
          aria-hidden="true"
        >
          <div className="relative flex h-24 w-24 items-center justify-center rounded-3xl border border-electric/30 bg-card shadow-glow-sm">
            <ShieldCheck className="h-10 w-10 text-electric" strokeWidth={1.5} />
            <span className="absolute inset-0 animate-pulse-dot rounded-3xl bg-electric/10" />
          </div>
        </motion.div>
      </div>

      <div className="mt-14 flex flex-col gap-4" data-testid="security-layers">
        {SECURITY_LAYERS.map((layer, i) => (
          <motion.div
            key={layer.name}
            initial={{ opacity: 0, x: -36, borderColor: "hsl(var(--border))" }}
            whileInView={{
              opacity: 1,
              x: 0,
              borderColor: "hsl(199 89% 60% / 0.45)",
              boxShadow: "0 0 0 1px hsl(199 89% 60% / 0.12), 0 18px 50px -22px hsl(224 76% 48% / 0.4)",
            }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.75, delay: i * 0.38, ease: EASE }}
            className="flex flex-col gap-4 rounded-2xl border bg-card p-6 sm:flex-row sm:items-center sm:justify-between sm:p-7"
            data-testid={`security-layer-${layer.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <div className="flex items-center gap-5">
              <span className="font-mono text-xs font-semibold tracking-[0.2em] text-electric">
                0{i + 1}
              </span>
              <div>
                <h3 className="font-display text-lg font-semibold">{layer.name}</h3>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                  Capa de protección
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 sm:justify-end">
              {layer.items.map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-border bg-surface px-3.5 py-1.5 text-xs font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground"
                >
                  {item}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
